<template>
  <b-card>
    <h1>Summations</h1>
    <vue-apex-charts :options="options" :series="series" type="bar" />
    <mixn ref="mixin" />
  </b-card>
</template>

<script>
import mixn from '@/components/mixn.vue'
import { BCard } from 'bootstrap-vue'
import VueApexCharts from 'vue-apexcharts'

export default {
  components: {
    VueApexCharts,
    BCard,
    mixn,
  },
  props: {
    sumData: {
      type: Array,
      default: () => [],
      required: false,
    },
    dataDashboard: {
      type: Object,
      required: false,
      default: () => ({}),
    },
    memberships: {
      type: Object,
      required: true,
      default: () => ({ NP: 0, NC: 0 }),
    },
    isSmallScreen: {
      type: Boolean,
      required: true,
      default: true,
    },
  },
  data() {
    return {
      series: [],
      options: {
        chart: {
          height: 400,
          type: 'line',
        },
        grid: {
          padding: {
            top: 40,
          },
        },
        noData: {
          text: 'Search to fetch the data!',
          align: 'center',
          verticalAlign: 'middle',
          offsetX: 0,
          offsetY: 0,
          style: {
            fontSize: '14px',
          },
        },
        stroke: {
          show: true,
          width: 2,
          curve: 'smooth',
        },
        dataLabels: {
          offsetY: -10,
          style: {
            colors: ['#333'],
            fontSize: '12px',
            fontWeight: 'bold',
          },
        },
        plotOptions: {
          bar: {
            dataLabels: {
              position: 'top',
            },
            columnWidth: '50%',
          },
        },
        xaxis: {
          type: 'category',
          tickPlacement: 'on',
        },
        markers: {
          size: 4,
        },
        labels: [],
      },
      dollars: new Intl.NumberFormat('en-US', {
        style: 'currency',
        currency: 'USD',
        minimumFractionDigits: 0,
      }),
    }
  },
  watch: {
    sumData: {
      immediate: true,
      handler() {
        this.setData()
      },
    },
    dataDashboard: {
      immediate: true,
      handler() {
        this.setData()
      },
    },
  },
  methods: {
    setData() {
      // Solo procesar si tenemos ambos datasets
      if (!this.sumData || !this.dataDashboard.year_data) return

      const newSeries = [
        {
          name: this.isSmallScreen ? 'Suma NP' : 'Suma New patient',
          type: 'column',
          data: [],
        },
        {
          name: this.isSmallScreen ? 'Suma NC' : 'Suma New Consultation',
          type: 'column',
          data: [],
        },
        {
          name: this.isSmallScreen ? 'Suma F/U' : 'Suma Follow Up',
          type: 'column',
          data: [],
        },
        {
          name: this.isSmallScreen ? 'Suma RS' : 'Suma Result',
          type: 'column',
          data: [],
        },
      ]

      this.sumData.forEach(({ income, month, year }) => {
        const date = `${month}-${year}`

        // Buscar los datos correspondientes en dataDashboard
        const dashboardMonth = this.dataDashboard.year_data.find(
          item => item.month === month && item.year === year
        )

        let nc = 0,
          np = 0,
          fu = 0,
          rs = 0

        if (dashboardMonth && dashboardMonth.facilities) {
          // Aplicar la misma lógica de suma que el primer componente
          dashboardMonth.facilities.forEach(res => {
            nc += (res['N/C'] || 0) + (res['INS-NC'] || 0)
            np += (res['N/P'] || 0) + (res['INS-NP'] || 0)
            fu += res['F/U'] || 0
            rs += res['R/S'] || 0
          })

          // Agregar membresías (misma lógica que el primer componente)
          nc += this.memberships.NC || 0
          np += this.memberships.NP || 0
        }

        // Agregar los valores a las series como se hacía originalmente
        newSeries[0].data.push({ x: `${date} - ${this.dollars.format(income)}`, y: np })
        newSeries[1].data.push({ x: `${date} - ${this.dollars.format(income)}`, y: nc })
        newSeries[2].data.push({ x: `${date} - ${this.dollars.format(income)}`, y: fu })
        newSeries[3].data.push({ x: `${date} - ${this.dollars.format(income)}`, y: rs })
      })

      this.series = newSeries
      this.$nextTick(() => {
        this.options = {
          ...this.options,
          colors: ['#cadbbb', '#fcc599', '#fbd5cc', '#FEB019'],
        }
      })
    },
  },
}
</script>
